import { Component, OnInit, ViewEncapsulation, ViewChild } from "@angular/core";
import { ProjectService } from "../../services/project/project.service";
import { Project } from "../../interfaces/project";
import { environment } from "../../../environments/environment";
import { ActivatedRoute } from "@angular/router";
import { RiskIndicator } from "../../interfaces/riskIndicator";
import { EditRiskIndicatorDialogComponent } from "../edit-risk-indicator-dialog/edit-risk-indicator-dialog.component";
import { RiskIndicatorService } from "../../services/risk-indicator/risk-indicator.service";
import { Retrospective } from "../../interfaces/retrospective";
import { RetrospectiveService } from "../../services/retrospective/retrospective.service";
import { RetrospectiveWizardComponent } from "../retrospective-wizard/retrospective-wizard.component";
import { DeleteItemConfirmationDialogComponent } from "../delete-item-confirmation-dialog/delete-item-confirmation-dialog.component";
import { MzToastService } from "ng2-materialize";
import { ExportService } from "../../services/export/export.service";
import { saveAs } from "file-saver";
import { chartColorScheme } from "../../utils/chartColortScheme";

@Component({
  selector: "app-risk-indicators",
  templateUrl: "./risk-indicators.component.html",
  styleUrls: ["./risk-indicators.component.scss"],
  encapsulation: ViewEncapsulation.None,
})
export class RiskIndicatorsComponent implements OnInit {
  env: any = environment;
  loading = true;
  project: Project;
  retrospectiveActive: boolean;
  riskIndicators: RiskIndicator[];
  retrospectives: Retrospective[];
  selectedRetrospectiveData: any;
  chartColorScheme = chartColorScheme;

  @ViewChild("EditRiskIndicatorModal")
  EditRiskIndicatorModal: EditRiskIndicatorDialogComponent;
  @ViewChild("RetrospectiveWizard")
  RetrospectiveWizard: RetrospectiveWizardComponent;
  @ViewChild("DeleteIndicatorConfirmationModal")
  DeleteIndicatorConfirmationModal: DeleteItemConfirmationDialogComponent;

  constructor(
    private exportService: ExportService,
    private toastService: MzToastService,
    private projectService: ProjectService,
    private riskIndicatorService: RiskIndicatorService,
    private retrospectiveService: RetrospectiveService,
    private route: ActivatedRoute
  ) {}

  ngOnInit() {
    /**
     * get all epics and feature by given projectID
     */
    this.route.params.subscribe(async (params: { id: string }) => {
      await this.loadData(params.id);
      this.retrospectiveActive = true;
      let result = await this.RetrospectiveWizard.continue();
      this.retrospectiveActive = false;
      if (result) {
        await this.loadData();
      }
    });
  }

  async openNewRiskIndicatorDialog() {
    this.EditRiskIndicatorModal.modalComponent.open();
  }

  async startRetrospective() {
    this.retrospectiveActive = true;
    let result = await this.RetrospectiveWizard.start(null);
    this.retrospectiveActive = false;
    if (result) {
      await this.loadData();
    }
  }

  async loadData(projectShortId?: string) {
    projectShortId = projectShortId || this.project.shortId;
    this.loading = true;
    this.project = await this.projectService.getProjectByShortId(
      projectShortId
    );
    this.riskIndicators = (
      await this.riskIndicatorService.getRiskIndicatorsByProjectId(
        this.project._id
      )
    ).sort(
      (x, y) =>
        new Date(x.created_at).getTime() - new Date(y.created_at).getTime()
    );
    this.retrospectives = (
      await this.retrospectiveService.getByProjectId(this.project._id)
    ).sort(
      (x, y) =>
        new Date(y.created_at).getTime() - new Date(x.created_at).getTime()
    );
    this.retrospectives.forEach((x) => (x["date"] = new Date(x.created_at)));
    this.selectRetrospective(this.retrospectives[0]);
    this.loading = false;
  }

  selectRetrospective(retrospective: Retrospective) {
    if (retrospective) {
      this.selectedRetrospectiveData = {
        id: retrospective._id,
        name: retrospective.name,
        date: new Date(retrospective.created_at),
        series: retrospective.votings.map((x) => {
          return {
            name: this.riskIndicators.filter(
              (y) => y._id === x.riskIndicatorId
            )[0].name,
            values: x.participants.map((y) => Number(y.estimation)),
          };
        }),
      };
    } else {
      this.selectedRetrospectiveData = null;
    }
  }

  async createRiskIndicatorClicked(newRiskIndicator) {
    await this.riskIndicatorService.createRiskIndicator(newRiskIndicator);
    await this.loadData();
  }

  async exportRetrospective() {
    var blob = await this.exportService.exportRetrospective(
      this.selectedRetrospectiveData.id
    );
    saveAs(
      blob,
      `Retrospektive ${this.selectedRetrospectiveData.name.replace(
        /[\\/:"*?<>|]+/,
        ""
      )}.xlsx`
    );
  }

  async deleteIndicatorClicked(id) {
    if (await this.DeleteIndicatorConfirmationModal.getResultAsync()) {
      for (let retrospective of this.retrospectives) {
        let index = retrospective.votings.findIndex(
          (x) => x.riskIndicatorId === id
        );
        if (index >= 0) {
          retrospective.votings.splice(index, 1);
          await this.retrospectiveService.save(retrospective);
        }
      }
      await this.riskIndicatorService.deleteRiskIndicatorById(id);
      this.toastService.show("Indikator gelöscht!", 4000, "confirm-toast");
      await this.loadData();
    }
  }
}



// WEBPACK FOOTER //
// /agir/src/app/components/risk-indicators/risk-indicators.component.ts